
function uvGetColor(type) {

  var colors = {
    building: 'white',
    building_fill: '#009ee3',
    building_fill_done: '#78AB46',
    building_fill_reserved: '#ffed00',

    building_highlight: '#666',
    building_highlight_selected: '#E5007D',
    building_highlight_selected_fill: '#E5007D',

    building_analyze: '#FFF',
    building_analyze_fill_highest: '#d7191c',
    building_analyze_fill_high: '#fdae61',
    building_analyze_fill_low: '#ABD9E9',
    building_analyze_fill_lowest: '#2C7BB6',
    building_analyze_fill_undefined: 'transparent',

    priority_area: '#FFF',
    priority_area_fill_highest: '#d7191c',
    priority_area_fill_high: '#fdae61',
    priority_area_fill_low: '#ABD9E9',
    priority_area_fill_lowest: '#2C7BB6',
    priority_area_fill_undefined: 'transparent',

    ratings_sector: 'red',
    ratings_sector_fill_highest: 'red',
    ratings_sector_fill_high: 'orange',
    ratings_sector_fill_low: 'green',
    ratings_sector_fill_lowest: 'blue',
    ratings_sector_fill_undefined: 'transparent',
  };

  return colors[type];
}

window.uvGetColor = uvGetColor;
